import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const Upload: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M15.34 16.17a.83.83 0 0 1-.59-.25L12 13.18l-2.74 2.74a.83.83 0 0 1-1.18 0 .85.85 0 0 1 0-1.18l3.33-3.33a.86.86 0 0 1 1.18 0l3.33 3.33a.84.84 0 0 1-.58 1.43Zm4.05 1.88a4.91 4.91 0 0 0 2.4-3A5 5 0 0 0 17 8.67h-.43a7.5 7.5 0 1 0-12.69 7.46.84.84 0 0 0 1.18.08.85.85 0 0 0 .07-1.21A5.83 5.83 0 0 1 8 5.52a5.83 5.83 0 0 1 7.11 4.19.81.81 0 0 0 .8.62H17a3.33 3.33 0 0 1 1.59 6.26.84.84 0 0 0 .4 1.57.8.8 0 0 0 .4-.11Zm-6.55 1.45V12a.84.84 0 0 0-.84-.83.83.83 0 0 0-.83.83v7.5a.83.83 0 0 0 .83.83.84.84 0 0 0 .84-.83Zm2.5-3.33a.83.83 0 0 1-.59-.25L12 13.18l-2.74 2.74a.83.83 0 0 1-1.18 0 .85.85 0 0 1 0-1.18l3.33-3.33a.86.86 0 0 1 1.18 0l3.33 3.33a.84.84 0 0 1-.58 1.43Z" />
  </Icon>
);

export default Upload;
